const overspeedAlarm = {
  licensePlate: "ป้ายทะเบียนรถ",
  AlarmInfo: "Alarm info",
  Type: "Type",
  faultTime: "เวลาที่เกิดข้อผิดพลาด",
  startTime: "เวลาเริ่มต้น",
  alarmStartSpeed: "เวลาเริ่มต้น",
  alarmEndSpeed: "เวลาสิ้นสุด",
  startLocation: "ตำแหน่งเริ่มต้น",
  endLocation: "ตำแหน่งสิ้นสุด",
  endTime: "เวลาสิ้นสุด"
} 
export default overspeedAlarm